import { viewProps } from '@/_core/pageSelector'
import bindData from '@/utilities/bindData'
type TargetProp = 'header' | 'breadcrumb' | 'pageHeading' | 'hero' | 'contentsHeader' | 'main' | 'asidePrimary' | 'asideSecondary' | 'footer'
type State = {
  [key in string]: any
}

/**
 * サーバから script 要素内で Global Object として受け取ったデータを、
 * local の state に reactive な状態を保って保存
 * @param state ページコンポーネント側で定義される local state
 * @param target assign 元のグローバルオブジェクトの対象プロパティ
 */
export default function(state: State, target: TargetProp) {
  if (!viewProps.local[target]) {
    console.error(`doesn't have data as "${target}".`)
    return
  }

  bindData(state, viewProps.local[target] as anyData)

  /**
   * ブラウザの「戻る」・「進む」が押下された際に state の内容を初期化する
   * @description 基本、「戻る」・「進む」であっても、JS オブジェクト自体は揮発するが、
   *              テキストフィールド系以外のフォーム系 HTML 要素（select や checkbox 等）は、見た目上選択されているかのような表示になってしまうため、
   *              結果、JS オブジェクトである state の内容は揮発しているが、HTML 要素側の「見た目上」は、さも選択されているかのように振る舞われており、state との乖離が発生する。
   *              よって、ブラウザのイベントが発火する際に state の初期化を行うことで、明示的にコンポーネントの watcher を動かし、初期化データでバインドしてからブラウザ遷移させる
   */
  window.addEventListener('pagehide', () => {
    bindData(state, viewProps.local[target] as anyData)
  })
}
